module.exports = __webpack_public_path__ + "static/img/merrymount.077e621.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hrdonates/merrymount.png
// module id = ZGyH
// module chunks = 0